import React from "react";
import { connect } from "react-redux";
import { setGif } from 'actions/gameChat';
import storage from "utils/Storage";
import { GIPHY_API } from 'utils/Helper';
import axios from "axios";
import { BsImage } from "react-icons/bs";

class Gif extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }

    handleClick = (e) => {
        e.preventDefault();
        this.setState({ show: !this.state.show })
    }

    render() {
        let logged = storage.getKey('logged') !== null ? true : false

        return (
            <div style={{ display: "inline-block", position: "relative" }}>
                <button 
                    type="button" 
                    onClick={logged ? this.handleClick : undefined} 
                    style={{ 
                        border: "none", 
                        background: "transparent", 
                        cursor: logged ? "pointer" : "default", 
                        padding: 0, 
                        display: "flex", 
                        alignItems: "center", 
                        color: "#b1bad3" 
                    }}
                >
                    <BsImage fontSize="18px" />
                </button>

                {
                    this.state.show &&
                    <div className="gif-container animated fadeInUp pl-3" style={{ background: "#1a2c38", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "8px" }}>
                        <GifList clicked={this.handleClick} props={this.props} />
                    </div>
                }
            </div>
        );
    }
}

class GifList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gifs: []
        }
    }

    componentDidMount() {
        let self = this;
        axios.get("/trending.json")
            .then(function (req) {
                let response = req.data;
                let trending = response.data;
                if (Array.isArray(trending)) {
                    trending.forEach((item, i) => {
                        self.setState(state => ({ gifs: [item, ...state.gifs] }));
                    });
                }
            })
            .catch(err => {
                console.error("Failed to load GIFs:", err);
            });
    }

    render() {
        const gifs = this.state.gifs.map((item, i) =>
            <MakeGif key={i.toString()} redux={this.props} image={item.images.downsized.url} />
        );
        return gifs;
    }
}

function MakeGif(props) {
    const { image } = props;

    const set = (e) => {
        props.redux.props.setGif(image);
        props.redux.clicked(e);
    }

    return (
        <>
            <img onClick={set} src={image} className={'img-fluid'} alt="GIF" style={{ width: "50px", height: "50px", objectFit: "cover" }} />
        </>
    );
}

export default connect(null, { setGif })(Gif);
